module.exports = __webpack_public_path__ + "static/media/sh.c39480d5.svg";